export type PaceBandDisplayOptions = {
  includePhaseType?: boolean;
};

const PACE_WARNING_LABELS = new Set(["Aggressive cut.", "Aggressive bulk."]);

const PACE_BAND_LABEL_MAP: Record<string, string> = {
  "Lean cut": "Lean",
  "Moderate cut": "Moderate",
  "Aggressive cut": "Aggressive",
  "Extreme cut": "Extreme",
  "Lean bulk": "Lean",
  "Moderate bulk": "Moderate",
  "Aggressive bulk": "Aggressive",
  "Extreme bulk": "Extreme",
  Maintain: "Moderate",
  "Off-maintain": "Extreme",
};

export function getPaceBandDisplayLabel(label: string, options: PaceBandDisplayOptions = {}): string {
  if (options.includePhaseType) return label;
  return PACE_BAND_LABEL_MAP[label] ?? label;
}

export function isRedundantPaceWarning(warning: string): boolean {
  return PACE_WARNING_LABELS.has(warning);
}

export function filterRedundantPaceWarnings(warnings: string[]): string[] {
  return warnings.filter((warning) => !isRedundantPaceWarning(warning));
}
